export interface ShareInTeamToggleBarProps {
  state: ShareInTeamBarState;
  onStateUpdate: (state: ShareInTeamBarState) => void;
  isCurrentlyLoading?: boolean;
}

export enum ShareInTeamBarState {
  ACTIVE = 1,
  INACTIVE = 2,
  UPSELLING = 3,
}
